module.exports = __webpack_public_path__ + "assets/already_confirmed.9945b579.svg";